export default __webpack_public_path__ + "static/sm-poster7-5a5910318191c792b3b27a143ecdf15e.png";